import React, { useEffect } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form, Input } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";

interface UpdateCompanyNameModalProps {
  show: boolean;
  handleClose: (isApiReload: boolean) => void;
  company: CompanyProp;
}

const UpdateCompanyNameModal: React.FC<UpdateCompanyNameModalProps> = ({
  show,
  handleClose,
  company,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/updateCompanyName", true);

  const onFinish = (values: any) => {
    const { companyName } = values;
    postApiData({ 
      companyName: companyName.trim(), 
      intPkCompanyID: company.intPkCompanyID 
    });
  };

  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);

  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Update Company Name"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateCompanyNameForm"
              initialValues={{ companyName: company.companyName }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">Company Name</span>
                }
                name="companyName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Company Name",
                  },
                  {
                    min: 3,
                    message: "Company Name Should be more than 2 characters",
                  },
                  {
                    pattern: /^[a-zA-Z0-9\s\-_.]+$/,
                    message: "Company Name can only contain letters, numbers, spaces, hyphens (-), underscores (_), and periods (.)",
                  },
                  {
                    whitespace: true,
                    message: "Company Name cannot be empty or contain only spaces",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Enter Company Name"
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Update Company Name"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateCompanyNameModal;

